import React from 'react';
import './style.scss';
import DeleteIcon from '@material-ui/icons/DeleteRounded';
import EditIcon from '@material-ui/icons/EditRounded';


export default function OrderOptions(props) {
    const onEditClicked = (e) => {
        if (props.onEditClicked)
            props.onEditClicked(e);
    };

    const onDeleteClicked = (e) => {
        if (props.onDeleteClicked)
            props.onDeleteClicked(e);
    };

    return (
        <div className="order-options">
            <span className="order-edit-icon-container" onClick={onEditClicked} aria-label="Edit">
                <div className="order-edit-icon">
                    <EditIcon fontSize="small"/>
                </div>
            </span>
            <span className="order-delete-icon-container" onClick={onDeleteClicked} aria-label="Delete">
                <div className="order-delete-icon">
                    <DeleteIcon fontSize="small"/>
                </div>
            </span>
        </div>
    );
}
